<script>
	import Helper from '../../Models/Helper';
	import Slider from '../../States/Slider';

	export let index;

	let properties = {};
	let active = false;

	function updateSlider(slides) {
		active = Slider.check(index, 'privacy', properties);
		if (active) {
			properties = Slider.properties(index);
			active = properties.active;
			Helper.title('Privacy beleid');
		}
	}

	Slider.subscribe(updateSlider);
</script>

<style>
	p.plain {
		font-size: 1.25em;
		line-height: 1.5em;
		color: var(--secondary-color);
	}

	h2 {
		color: var(--primary-color) !important;
		margin-top: 2em;
		margin-bottom: 1em;
	}

	div.constraint {
		max-width: 45em;
	}

	p a {
		font-weight: bold;
		color: var(--secondary-color);
	}

	a.button {
		text-align: left;
	}
</style>

<div class="box feature" class:active>
	<div class="menu">
		<div class="begin">
			<div class="title">Privacy beleid</div>
		</div>
		<div class="end">
			<div class="item" on:click="{event => Slider.close()}">
				<i class="fas fa-times"></i>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="constraint">
			<h1>Privacy beleid</h1>
			<p class="plain">Wij gaan zorgvuldig om met je persoonlijke gegevens, om je privacy te beschermen. Op deze pagina vertellen we welke gegevens we verzamelen als je onze website gebruikt, waarom we deze gegevens verzamelen en wat we ermee doen.</p>
			<p>Dit privacybeleid is van toepassing op de website van de BasisBijbel. Door gebruik te maken van deze website geef je aan dat je het privacy beleid van stichting BasisBijbel accepteert.</p>

			<h2>Gebruik van onze website</h2>
			<p>Als je van alle functies van de website van de BasisBijbel gebruik wil maken, zoals verzen opslaan en aantekeningen maken, moet je een account aanmaken. Dat account is nodig om je verzen en aantekeningen te kunnen opslaan. Hiervoor is je emailadres nodig, een wachtwoord en een naam. De naam hoeft niet je echte naam te zijn. Je gegevens worden opgeslagen op een beveiligde server. Bovendien worden ze versleuteld: niemand kan ze zien. Je e-mail adres wordt verder nergens voor gebruikt, ook niet voor reclame. Het wordt nooit doorgestuurd of verhandeld aan derden.</p>
			<p>Het maken van een account is dus niet verplicht, maar als je geen account hebt, kun je alleen de lees- en zoekfuncties en de bladwijzer gebruiken.</p>

			<h2>Uitschrijven</h2>
			<p>Wil je je account verwijderen? Zorg eerst dat je ingelogd staat. Klik daarna in het menu op je naam en volg de aanwijzingen. Al je gegevens en aantekeningen worden dan definitief gewist.</p>

			<h2>Contact</h2>
			<p>Als je ons een e-mail stuurt, wordt dat bericht bewaard. Je e-mail adres wordt nooit gebruikt voor reclame en wordt nooit doorgestuurd of verhandeld aan derden.</p>

			<h2>Cookies</h2>
			<p>Als je daarvoor toestemming gegeven hebt, gebruikt deze website “cookies” (kleine bestandjes die op je computer worden geplaatst). De cookies geven ons inzicht in het gebruik van de website. Dit maakt het ons  mogelijk de website te verbeteren.</p>

			<h2>Vragen of klachten?</h2>
			<p>We controleren regelmatig of we aan dit privacybeleid voldoen. Als je vragen of klachten hebt over ons privacybeleid, kun je contact met ons opnemen.</p>
		</div>
	</div>
</div>